const sampleStatusValueMap = {
    "draft": 0,
    "ready_for_shipment": 1,
    "shipped": 2,
    "report_ready": 3,
    "associated_to_workflow": 5
}

export const SampleStatusMasterData = {
    sampleStatusValueMap: sampleStatusValueMap
}